// In step 1, you create the AuthContext object and export it. This should be in a separate file, for example auth-context.js.

import { createContext } from "react";

export const AuthContext = createContext();
